import { computed, ref, watch } from 'vue'
import { useStore } from 'vuex'
import useCompanies from '@/modules/Company.js'

const dropdown_companies = ref([])
const dropdown_company_filters = ref({
  name: '',
})
const loading = ref(false)

let lastPage = -1

export default function useCompaniesDropdown(perPage = 10) {
  const store = useStore()
  const userCompanies = store.getters['authenticated_user'].companies
  const userProfile = store.getters['authenticated_user'].user_profile
  const userProfileName = (userProfile && !Array.isArray(userProfile) ? userProfile.name : null) ?? 'Admin'
  const allCompaniesAllowedUserProfiles = ['Admin', 'Engenheiro', 'Técnico']
 

  const { companies, listCompanies, company_filters } = useCompanies()

  const loadNextCompaniesPage = () => {
    const page = currentPage() + 1

    if (page === lastPage) return

    loading.value = true

    listCompanies(currentPage() + 1, perPage).then(() => {
      loading.value = false

      const companiesNotLoaded = [...companies.value]

      const companiesList = [...dropdown_companies.value, ...companiesNotLoaded]

      if (allCompaniesAllowedUserProfiles.includes(userProfileName)) {
        dropdown_companies.value = companiesList
      } else {
        const companiesListFiltered = companiesList.filter((company) => {
          return userCompanies.some((userCompany) => {
            return userCompany.id === company.id
          })
        })

        dropdown_companies.value = companiesListFiltered
      }

      lastPage = page
    })
  }

  const currentPage = () => {
    return Math.floor(dropdown_companies.value.length / perPage)
  }

  const onCompaniesDropdownScroll = (e) => {
    if (
      e.srcElement.offsetHeight + e.srcElement.scrollTop >=
      e.srcElement.scrollHeight
    ) {
      if (!loading.value) {
        loadNextCompaniesPage()
      }
    }
  }

  const updateFilters = async () => {
    if (!loading.value) {
      company_filters.value = dropdown_company_filters.value
      dropdown_companies.value = []
      lastPage = -1

      loadNextCompaniesPage()
    }
  }

  watch(dropdown_company_filters.value, () => {
    setTimeout(() => {
      updateFilters()
    }, 250)
  })

  return {
    dropdown_companies: computed(() => dropdown_companies.value),
    dropdown_company_filters: computed(() => dropdown_company_filters.value),
    loadNextCompaniesPage,
    onCompaniesDropdownScroll,
  }
}
